export enum UserRoleEnum {
  AGENT = 50,
  LEADER = 100,
  ADMIN = 1000,
}
